import { Component, Injectable, OnInit, AfterViewInit, Input, Compiler, HostListener } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router, NavigationEnd } from "@angular/router";


import { AlertService } from "app/utils/alert.service";
import { AuthenticationService } from "app/services/authentication.service";
import { BindComponentService } from "app/utils/bind.component.service";
import { OfferBannerService } from "app/services/offer.banner.service";
import { DataPackOfferTO } from "app/models/dataPackOfferTO.model";
import { Filter } from "app/models/filter.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Mobilesearch } from "app/home/paraEmpresas/header/mobilesearch/content.component";
import { LoadingComponent } from "app/home/paraEmpresas/modalLoading/content.component";

import * as _ from "lodash";
import { VoiceConsumeService } from "app/services/voice.consume.service";
import { DataPackLine } from "app/models/dataPackLine.model";
import { DataPackGroup } from "app/models/dataPackGroup.model";
import { ConsumeComponent } from "app/home/paraEmpresas/consume/content.component";
import { NavigationStart } from "@angular/router/src/router";
import { PackagesService } from "app/services/packages.service";
import { debounce, debounceTime } from "rxjs/operators";
import { VivoSyncService } from "app/services/vivo.sync.service";
import 'rxjs/add/operator/switchMap';

/**
 * @version $Id$
 */
@Component({
  selector: "header",
  templateUrl: "./header.html"
})
@Injectable()
export class HeaderComponent implements OnInit, AfterViewInit {

  private static readonly GROUPS_FETCH_SIZE: number = 20; //50
  private static readonly LINES_FETCH_SIZE: number = 20; //50
  private readonly filterOnly4GList: string[] = ['CONSUME_VOICE_FILTER', 'CONSUME_DATA_4G_FILTER', 'BLOCK_VOICE_FILTER', 'BLOCK_VIVO_UP_FILTER'];  // ALTERADO
  private readonly filterOnly5GList: string[] = ['CONSUME_DATA_5G_FILTER']; // ALTERADO

  private user: string;
  private account: string;
  private plan: string;
  private loggedManagerType: string;
  private nifType: string;
  private nif: string;
  private totalLines: string;
  private typeFilter: string;
  private typeValue: string;
  private hasOffers: boolean;
  private dataPack: boolean;
  private arrayOffers: Array<DataPackOfferTO> = new Array<DataPackOfferTO>();
  private filter: Filter = new Filter();
  private form: FormGroup;
  private currentUrl: string;
  private linesFetchSize: number = HeaderComponent.LINES_FETCH_SIZE;
  private isVoiceConsumption: boolean = true;
  private hasOverBalanceMonetaryVoice: boolean;
  private hasHibridService: boolean;
  private hasPackageHireFlag: boolean;
  private isData: boolean;
  private showB2B2CFuncionality: boolean;
  private isAceptTerm: boolean;
  private vivoSyncOnOff: boolean = false; // Default false ?
  private activeTabToExecuteFilter: string; // ALTERADO
  private isPortfolio5G: number // ALTERADO


  constructor(
    private voiceConsumeService: VoiceConsumeService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private authService: AuthenticationService,
    private offerBannerService: OfferBannerService,
    private bindComponent: BindComponentService,
    private router: Router,
    private packagesService: PackagesService


  ) { }


  @HostListener('window:scroll') onScroll() {
    this.offSetManager();
  }

  ngOnInit() {
    this.viewCurrentURL();
    this.loadView();
    this.loadOffers();
    this.form = this.formBuilder.group({
      rdnome: ["", Validators.required],
      rdnumero: ["", Validators.required],
      rdgroup: ["", Validators.required],
      rddado: ["", Validators.required]
    });

    this.bindComponent.subscribe(BindComponentService.VALUE_SERVICE_VOICE,
      data => {
        this.hasOverBalanceMonetaryVoice = data['hasOverBalanceMonetaryVoice'];
        this.hasHibridService = data['hasHibridService'];
      }
    );

    this.bindComponent.subscribe(BindComponentService.FILTER_ACTIVE_TAB,
      data => {
        this.activeTabToExecuteFilter = data;
      }
    );
  }


  public viewCurrentURL() {
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.onNavigationChanged(event);
      }
    });
  }

  private onNavigationChanged(event: NavigationEnd) {
    this.currentUrl = event.url;
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: "static",
      keyboard: false
    });
  }

  private loadView() {
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if (!isNil(data)) {
      this.user = data['user'];
      this.account = data['account'];
      this.plan = data['plan'];
      this.loggedManagerType = data['loggedManagerType'];
      this.dataPack = data['dataPack'];
      this.nifType = data['nifType'];
      this.nif = data['nif'];
      this.totalLines = data['totalLines'];
      this.hasPackageHireFlag = data['hasPackageHireFlag'];
      this.isData = data['isData'];
      this.vivoSyncOnOff = data['vivoSyncOnOff'];
     // this.isAceptTerm = data['acceptTerm'];
      // Pedido 407598: Se não for Gestor de empresa não exibe menu do TOP UP - INICIO
      if (this.loggedManagerType === 'COMPANY_MANAGER' || this.loggedManagerType === 'COMPANY_MASTER_MANAGER') {
        this.showB2B2CFuncionality = data['showB2B2CFuncionality'];
      } else {
        this.showB2B2CFuncionality = false;
      }
      // Pedido 407598: Se não for Gestor de empresa não exibe menu do TOP UP - FIM

      this.bindComponent.set(BindComponentService.HAS_PACKAGE_HIRE_FLAG, this.hasPackageHireFlag);

      this.packagesService.getServiceAcceptTerm().subscribe(
        data => {;
          let value : any = data;
          this.isAceptTerm = value;
      });
    }

    function isNil(value) {
      return value == null;
    }
  }

  private loadOffers() {
    this.offerBannerService.getOffers().subscribe(
      data => {
        let value: any = data
        this.arrayOffers = value;
        //this.activateMenuItem();
        if (this.arrayOffers.length > 0) {
          this.hasOffers = true;
        } else {
          this.hasOffers = false;
        }

      },
      err => {
        //this.activateMenuItem();
        this.alertService.error(err.result, err);
      }
    );
  }

  public loadingSearch() {
    let value;
    let filter;
    this.router.routerState.root.queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        filter = params['filter'];
        value = params['typefilter'];

      });
    if (this.currentUrl === '/Portal/data/consumption?typefilter=' + value + '&filter=' + filter) {
      let array = {
        isLoadview: true,
        filtered: true
      }
      this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION_FILTER, array);
    }
  }


  public redirect(andress: string) {
    this.loadingSearch();
    if (andress === '/Portal/data/hiring') {
      this.getTermAcept(andress);
    } else {
      this.router.navigate([andress], { queryParams: { filter: false } });
      this.router.setUpLocationChangeListener();
    }
    //this.activateMenuItem();
  }


  public getTermAcept(andress: string) {
    this.router.navigate([andress], { queryParams: { filter: this.isAceptTerm } });
  }
  public redirectLogin(andress: string) {
    this.router.navigate([andress], { queryParams: { filter: false } });
  }


  private doFilter() {
    let cleanUrl = this.router.url.split("?")[0];
    this.router.navigate([cleanUrl], { queryParams: { typefilter: this.typeValue, filter: true } });
    //this.activateMenuItem();
    this.openModalLoading();

    this.voiceConsumeService.searchLines(1, 20, this.typeValue)
    .switchMap(
      data => {
        this.isPortfolio5G = data['filterLines'][0]['is5GPortifolio'];
        return this.voiceConsumeService
        .countSearchLines(1, this.linesFetchSize, this.typeValue);
      }).subscribe(
      data => {

        if (data['code'] == "EMPTY" || data['recordCount'] == 0) {
          this.alertService.error("Nenhum dado encontrado!", null);
          return
        }

        //console.log("activeTabToExecuteFilter =>", this.activeTabToExecuteFilter);
        //console.log(this.isPortfolio5G);

        let msgIncompatiblePortfolioType: string = '';

        if (this.activeTabToExecuteFilter && this.filterOnly4GList.includes(this.activeTabToExecuteFilter)) {

          if (this.isPortfolio5G) { 
            msgIncompatiblePortfolioType = this.getIncompatiblePortfolioTypeMsg(this.activeTabToExecuteFilter);
            this.alertService.error(msgIncompatiblePortfolioType, null);
          }
        
        } else if (this.activeTabToExecuteFilter && this.filterOnly5GList.includes(this.activeTabToExecuteFilter)) {
          if (!this.isPortfolio5G) { 
            msgIncompatiblePortfolioType = this.getIncompatiblePortfolioTypeMsg(this.activeTabToExecuteFilter);
            this.alertService.error(msgIncompatiblePortfolioType, null);
          }
        }    
        
        if (!msgIncompatiblePortfolioType) {
          let modalRef = this.modalService.open(Mobilesearch, {
            backdrop: "static",
            keyboard: false
          });

          modalRef.componentInstance.count = data['recordCount'];
          modalRef.componentInstance.typeValue = this.typeValue;
          modalRef.componentInstance.paginationSearch = data['paginationSearch'];
          modalRef.componentInstance.isVoiceConsumption = this.isVoiceConsumption;
          modalRef.componentInstance.hasOverBalanceMonetaryVoice = this.hasOverBalanceMonetaryVoice;
          modalRef.componentInstance.hasHibridService = this.hasHibridService;
        }
        
        this.typeValue = null
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        
      },
      err => {
        if (err.codigo === "EMPTY") {
          this.alertService.warn(err.result);
        }
        this.redirect(cleanUrl);
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION, true);
      }
    );

  }

  private getIncompatiblePortfolioTypeMsg(selectedTabToExecuteFilter: string): string {
    switch(selectedTabToExecuteFilter) {
      case 'CONSUME_VOICE_FILTER':
        return 'Linha Portfólio 5G não possui serviço de Voz';

      case 'CONSUME_DATA_4G_FILTER':
        return 'Linha Portfólio 5G';

      case 'CONSUME_DATA_5G_FILTER':
          return 'Linha Portfólio 4G';   

      case 'BLOCK_VOICE_FILTER':
          return 'Linha Portfólio 5G não possui serviço de Voz';

      case 'BLOCK_VIVO_UP_FILTER':
            return 'Linha Portfólio 5G não possui serviço de Vivo Up';

      default:
        return 'Erro na execução do filtro';
    }
  }

  ngAfterViewInit() {
    this.bindComponent.subscribe(BindComponentService.IS_VOICE_CONSUMPTION,
      condicao => {
        this.isVoiceConsumption = condicao;
      }
    );
    this.bindComponent.subscribe(BindComponentService.IS_LOGIN_SUCESS,
      condicao => {
        this.viewCurrentURL();
        this.loadView();
        this.loadOffers();

      }
    );
  }

  private isLoginURL() {
    return (
      this.currentUrl === "/Portal/data" || _.includes(this.currentUrl, "login")
    );
  }

  private logout() {
    this.viewCurrentURL();
    this.authService.logout().subscribe(
      data => {
        this.redirectLogin("/Portal/data/login");
        localStorage.setItem("ALREADY_OPEN", "false");
        localStorage.setItem('GET_AUTENTICATED_USER', null);
        localStorage.clear();
      },
      err => {
        this.redirectLogin("/Portal/data/login");
        localStorage.setItem('GET_AUTENTICATED_USER', null);
        localStorage.setItem("ALREADY_OPEN", "false");
        localStorage.clear();
      }
    );
  }

  private offSetManager() {
    if (null !== document.getElementById("navbar_top")) {
      let yOffset = 135;
      let currYOffSet = window.pageYOffset;
      if (yOffset < currYOffSet) {
        document.getElementById("navbar_top").style.display = "block";
      } else {
        document.getElementById("navbar_top").style.display = "none";
      }
    }
  }

  /** AS CHAMADAS A ESSA FUNCAO FORAM REMOVIDAS POIS O MENU NAO SERA MAIS SOBRE O CAROUSSEL. AS CHAMADAS FORAM ALTERADAS PARA this.activateMenuItem() APENAS*/
  private calculateMenuHeight() {
    let image_carousel = document.getElementById("carousel-image-0");
    let width;
    /* calculando dinamicamente o margin-top do navbar-menu e do main-content, de acordo com a resolucao e o tamanho da imagem no carousel */
    if (image_carousel != null) {
      let width = image_carousel.offsetWidth;
      /* margem do topo eh negativa e a proporcao entre width e height eh 16/5 */
      let margin_top = width * -5 / 16;
      let margin_px = margin_top + "px";
      let navbarTop = document.getElementById("navbar_top_1");
      /*adicionando o margin-top no menu*/
      navbarTop.style.marginTop = margin_px;
      /* adicionando o margin-top no main-content */
      margin_top = Math.floor(margin_top * -1) - 119;
      let style = document.createElement("style");
      document.head.appendChild(style);
      let sheet = style.sheet;
      let ua = window.navigator.userAgent;
      let msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        // If Internet Explorer, return version number
        (sheet as CSSStyleSheet).addRule(".main-content.background-gray", "margin-top: " + margin_top + "px !important;");
      } else {
        // If another browser, return 0
        (sheet as CSSStyleSheet).insertRule(".main-content.background-gray { margin-top: " + margin_top + "px !important; }");
      }
      //sheet.addRule('.main-content.background-gray','margin-top: '+margin_top+"px !important;");
      //this.activateMenuItem();
    }
  }

  private activateMenuItem() {
    document.getElementById("menu-consumption") && document.getElementById("menu-consumption").classList.remove("menu-active");
    document.getElementById("menu-calendar") && document.getElementById("menu-calendar").classList.remove("menu-active");
    document.getElementById("menu-block") && document.getElementById("menu-block").classList.remove("menu-active");
    document.getElementById("menu-reports") && document.getElementById("menu-reports").classList.remove("menu-active");
    document.getElementById("menu-administration") && document.getElementById("menu-administration").classList.remove("menu-active");
    document.getElementById("menu-vivosync") && document.getElementById("menu-vivosync").classList.remove("menu-active");


    // Pedido 407598: teste se exibira o menu de contratação de pacotes b2b2c
    if (this.showB2B2CFuncionality) {
      document.getElementById("menu-fatherHiring") && document.getElementById("menu-fatherHiring").classList.remove("menu-active");
    }
    // Pedido 407598: teste se exibira o menu de contratação de pacotes b2b2c - FIM
    setTimeout(() => {
      if (null !== document.getElementById("breadcrumb")) {
        let breadcrumb = document
          .getElementById("breadcrumb")
          .getAttribute("href");
        let arr = breadcrumb.split("/");
        let menuId = "menu-".concat(arr[arr.length - 1]);
        if (null !== document.getElementById(menuId)) {
          if (menuId == 'menu-hiring' || menuId == 'menu-packages') {
            document.getElementById('menu-fatherHiring') && document.getElementById('menu-fatherHiring').classList.add("menu-active");
          } else {
            document.getElementById(menuId) && document.getElementById(menuId).classList.add("menu-active");
          }
        }
      }
    }, 10);
  }

  public viewMenuContractPackages(loggedManagerType:string):boolean{
    if(loggedManagerType === 'COMPANY_MANAGER' && this.isAceptTerm){
      return true;
    }else if (loggedManagerType ==='COMPANY_MASTER_MANAGER'){
      return true;
    }
    return false;
  }


}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/header/header.component.ts